import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

declare var grecaptcha: any;

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent {

  anacCode: string;
  submited: boolean;
  loading: boolean = false;
  resetCompleted: boolean = false;

  form: FormGroup;

  constructor(private dialogRef: MatDialogRef<ResetPasswordComponent>,
              private authorizationService: AuthorizationService,
              private configService: ConfigService,
              private notificationService: NotificationService) {};

  ngOnInit(): void {
    this.form = new FormGroup({
      anacCode: new FormControl({value: '', disabled: false}, Validators.required)
    });
  }              

  async confirm(): Promise<void> {
    this.submited = true;
    if (this.form.invalid || this.loading) {
      return;
    }

    const anacCode = this.form.controls["anacCode"].value.trim();
    const tokenReCaptcha = await this.genereteReCaptchaToken();

    this.loading = true;
    this.authorizationService.externalCrewResetPassword(anacCode, tokenReCaptcha).subscribe({
    next: () => {
      this.loading = false;
      this.resetCompleted = true;
    },
    error: (error: HttpErrorResponse) => {
      this.loading = false;
      this.notificationService.error('Ocorreu um erro inesperado!');
    }
    });
  }

  private async genereteReCaptchaToken(): Promise<string> {
    const token = await grecaptcha.enterprise.execute(this.configService.settings.recaptcha_key, { action: 'externalLogin' });
    return token;
  }

  backToLogin(): void {
    this.dialogRef.close();
  }
}
